import { Controller } from "@hotwired/stimulus"

// Connects to data-controller="filtering"
export default class extends Controller {
  static targets = ['icon', 'body', 'filters']

  connect() {
    this.filtersTarget.innerHTML = ''
    this.element.querySelectorAll('[id$=_search] .form-control, [id$=_search] .form-select').forEach(elem => {
      if (!!elem.value && elem.type != "hidden") {
        const field_id = elem.getAttribute('id')
        const label_field = this.element.querySelector('label[for="' + field_id + '"]')
        const label_text = !!label_field ? label_field.textContent : (elem.getAttribute('placeholder') ? elem.getAttribute('placeholder') : elem.dataset.label)
        let ransackValue = null
        if (elem.tagName == 'SELECT') {
          ransackValue = Array.from(elem.selectedOptions).map(i => i.innerText).join(' ou ')
        } else {
          ransackValue = elem.value
        }
        const result_label = `${label_text}: ${ransackValue}`
        let filter = `<span class="js-filter badge bg-secondary">${result_label}`
        if (!['q_s', 'q_discarded_at_not_null'].includes(elem.getAttribute('id'))) {
          filter += `&nbsp;<i class="bi bi-x js-delete-filter"
            data-action="click->filtering#remove_field"
            data-filtering-field-id-param="#${field_id}"></i>`
        }
        filter += '</span>'
        this.filtersTarget.innerHTML += filter
      }
    })
  }

  toggle() {
    if (this.iconTarget.classList.contains('bi-chevron-right')) {
      this.iconTarget.classList.remove('bi-chevron-right')
      this.iconTarget.classList.add('bi-chevron-down')
      this.bodyTarget.style.display = "block"
    } else {
      this.iconTarget.classList.remove('bi-chevron-down')
      this.iconTarget.classList.add('bi-chevron-right')
      this.bodyTarget.style.display = "none"
    }
  }

  remove_field({ params }) {
    this.element.querySelector(params.fieldId).value = ''
    this.element.querySelector('button[type=submit]').click()
  }
}
